import LandingPage from './pages/LandingPage';

const App = () => {
  return (
    <div className="mx-md-5 my-md-5 m-4">
      <LandingPage />
    </div>
  );
}

export default App;
